import React, { useEffect, useState } from 'react';
import { Button, Form, Input } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';

import { teamsMembersListActions, getCurrentTeamMembersList, getTeamsMembersForCurrentTeamMembersList } from '../../../core/teams-members-list';
import { CustomPagination } from '../common/Pagination';
import { ResumeMember } from '../community/ResumeMember';

export const MembersList = ({ teamId }) => {
    const dispatch = useDispatch();
    const { isPending, currentPage, lastPage } = useSelector(getCurrentTeamMembersList);
    const members = useSelector(getTeamsMembersForCurrentTeamMembersList);
    const [query, setQuery] = useState('');

    useEffect(() => {
        if(!isPending)
            dispatch(teamsMembersListActions.loadTeamMembers({teamId}));
    }, [dispatch])

    const handleChangePage = (page) => {
        dispatch(teamsMembersListActions.loadTeamMembers({teamId, page}));
    }

    const handleSearch = () => {
        dispatch(teamsMembersListActions.loadTeamMembers({ teamId, page: 1, query }));
    }

    const handleKeyPress = (event) => {
        if(event.key === 'Enter') {
            handleSearch();
        }
    }
    
    return (
        <>
            <div className='row filter mb-3'>
                <div className='col-lg-6'>
                    <Form onSubmit={e => { e.preventDefault() }}>
                        <div className="search-member-input rounded border d-flex align-items-center">
                            <Button color='link' className='text-muted p-0' onClick={handleSearch}>
                                <svg xmlns="http://www.w3.org/2000/svg" width={20} height={21} viewBox="0 0 20 21" fill='currentColor'>
                                    <g>
                                        <path d="M18.1,17.4L18.1,17.4L18.1,17.4c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3
                                                            c0,0.1-0.1,0.2-0.2,0.3s-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2l-3.7-3.7l0,0l0,0
                                                            c-1.4,1.1-3.2,1.6-5,1.4c-1.8-0.2-3.5-1-4.7-2.4C2.2,12.6,1.6,10.8,1.6,9c0.1-1.8,0.8-3.5,2.1-4.8c1.3-1.3,3-2,4.8-2.1
                                                            c1.8-0.1,3.6,0.6,4.9,1.8c1.4,1.2,2.2,2.9,2.4,4.7c0.2,1.8-0.3,3.6-1.4,5l0,0l0,0L18.1,17.4z M3.4,9.3L3.4,9.3
                                                            C3.4,10.7,3.9,12,5,13c1,1,2.4,1.6,3.8,1.6h0c1.1,0,2.1-0.3,3-0.9c0.9-0.6,1.6-1.4,2-2.4c0.4-1,0.5-2.1,0.3-3.1
                                                            c-0.2-1-0.7-2-1.5-2.8S10.8,4.2,9.8,4c-1-0.2-2.1-0.1-3.1,0.3c-1,0.4-1.8,1.1-2.4,2C3.7,7.1,3.4,8.2,3.4,9.3z"/>
                                        <path d="M17.5,18.9c-0.1,0-0.2,0-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.2L13.1,15c-1.5,1.1-3.3,1.6-5.1,1.5
                                                            c-1.8-0.2-3.5-1-4.7-2.4c-1.2-1.4-1.8-3.1-1.8-5c0.1-1.8,0.8-3.6,2.1-4.9c1.3-1.3,3-2,4.9-2.1c1.8-0.1,3.6,0.6,5,1.8
                                                            c1.4,1.2,2.2,2.9,2.4,4.7c0.2,1.8-0.3,3.6-1.5,5.1l3.8,3.8l0,0c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.4s0,0.2-0.1,0.4
                                                            s-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2C17.7,18.9,17.6,18.9,17.5,18.9z M13.1,14.8L13.1,14.8l3.8,3.8c0.1,0.1,0.2,0.1,0.3,0.2
                                                            c0.2,0.1,0.4,0.1,0.6,0c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3
                                                            c0-0.1-0.1-0.2-0.2-0.3l-0.1,0l0,0l-3.7-3.7l0.1-0.1c1.1-1.4,1.6-3.2,1.4-5c-0.2-1.8-1-3.4-2.4-4.6s-3.1-1.8-4.9-1.8
                                                            C6.7,2.2,5,3,3.7,4.2c-1.3,1.3-2,3-2.1,4.8c-0.1,1.8,0.6,3.5,1.8,4.9c1.2,1.4,2.8,2.2,4.6,2.4C9.8,16.5,11.6,16,13.1,14.8
                                                            L13.1,14.8z M8.8,14.7c-1.5,0-2.8-0.6-3.8-1.6c-1-1-1.6-2.4-1.6-3.8l0,0c0-1.1,0.3-2.1,0.9-3c0.6-0.9,1.4-1.6,2.4-2
                                                            c1-0.4,2.1-0.5,3.1-0.3c1.1,0.2,2,0.7,2.8,1.5c0.8,0.8,1.3,1.7,1.5,2.8c0.2,1.1,0.1,2.1-0.3,3.1c-0.4,1-1.1,1.8-2,2.4
                                                            C10.9,14.4,9.8,14.7,8.8,14.7z M3.4,9.3C3.4,10.7,4,12,5,13c1,1,2.3,1.6,3.8,1.6c1.1,0,2.1-0.3,3-0.9c0.9-0.6,1.6-1.4,2-2.4
                                                            c0.4-1,0.5-2,0.3-3.1c-0.2-1-0.7-2-1.5-2.7C11.8,4.7,10.8,4.2,9.8,4c-1-0.2-2.1-0.1-3.1,0.3c-1,0.4-1.8,1.1-2.4,2
                                                            C3.7,7.2,3.4,8.2,3.4,9.3L3.4,9.3z"/>
                                    </g>
                                </svg>
                            </Button>
                            <Input
                                type="text"
                                className='border-0'
                                id="search_members"
                                name="search_members"
                                placeholder="Search members by name or email"
                                onChange={({ target: { value } }) => { setQuery(value) }}
                                onKeyDown={handleKeyPress}
                            />
                        </div>
                    </Form>
                </div>
            </div>

            <div className="border rounded">
                <div className='p-3 d-flex justify-content-between border-bottom'>
                    <div><h6 className="font-weight-semibold mb-0">Member name</h6></div>
                    <div><h6 className="font-weight-semibold mb-0 text-center mr-4">Thinking Talents</h6></div>
                    <div><h6 className="font-weight-semibold mb-0 text-center">Mind Patterns</h6></div>
                </div>

                {!isPending && members?.map(memberData => {
                    return <ResumeMember key={memberData.user_id} user={memberData.member} isLeader={memberData.leader} />
                })}
            </div>

            <CustomPagination
                currentPage={currentPage}
                totalPages={lastPage}
                onPageChange={handleChangePage}
            />
        </>
    )
}